export { default } from './ProductPage';
